import axios from "axios";

const GetUnsettledShipmentsReport = {
    getByCarrierId(carrierId) {
        return axios.get(
            `https://api.shippersedge.com/carrierportal/auroraunsettled/${carrierId}`,
            { headers: { "x-api-key": "vdhy8wwjUJrwhxFpfuECTiAW" }, responseType: "blob" }
        );
    }
};

export default GetUnsettledShipmentsReport;
